import { useState } from 'react';
import axios from 'axios';
import { API } from '../config';
import { TIPO_DIREITO_LABEL } from './rotulos';
import { cpfValido, MSG_CPF } from '../documentosId';

// Todos os direitos (rotulos unicos em rotulos.js), menos "Outro"
const TIPO_OPTIONS = Object.entries(TIPO_DIREITO_LABEL).filter(([k]) => k !== 'OUTRO').map(([value, label]) => ({ value, label }));

export default function DsarForm({ token, onVoltar }) {
  const [form, setForm] = useState({ titularNome: '', titularEmail: '', titularCpf: '', tipoDireito: '', descricao: '' });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const salvar = async () => {
    setErro('');
    if (!form.titularNome || !form.titularEmail || !form.tipoDireito || !form.descricao) {
      return setErro('Preencha nome, e-mail, tipo de direito e descrição');
    }
    if (form.titularCpf && !cpfValido(form.titularCpf)) return setErro(MSG_CPF);
    setLoading(true);
    setErro('');
    try {
      const res = await axios.post(`${API}/dsar/solicitacoes`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSucesso(`Solicitação criada com protocolo ${res.data.protocolo}`);
      setTimeout(() => onVoltar(), 1200);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao criar solicitação');
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="flex-center gap-8 mb-20">
        <button onClick={onVoltar} className="link-back">← Voltar</button>
        <h2 className="page-title">Nova solicitação</h2>
      </div>

      <div className="card">
        {erro && <div className="alert-error">{erro}</div>}
        {sucesso && <div className="alert-success">{sucesso}</div>}

        <div className="form-grid mb-16">
          <div className="form-group">
            <label>Nome do titular</label>
            <input value={form.titularNome} onChange={e => setForm({ ...form, titularNome: e.target.value })} placeholder="Nome completo" />
          </div>
          <div className="form-group">
            <label>E-mail do titular</label>
            <input type="email" value={form.titularEmail} onChange={e => setForm({ ...form, titularEmail: e.target.value })} placeholder="email@exemplo.com" />
          </div>
        </div>

        <div className="form-grid mb-16">
          <div className="form-group">
            <label>CPF (opcional)</label>
            <input value={form.titularCpf} onChange={e => setForm({ ...form, titularCpf: e.target.value })} placeholder="000.000.000-00" />
          </div>
          <div className="form-group">
            <label>Tipo de direito (LGPD Art. 18)</label>
            <select value={form.tipoDireito} onChange={e => setForm({ ...form, tipoDireito: e.target.value })}>
              <option value="">Selecione...</option>
              {TIPO_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
        </div>

        <p className="text-xs text-muted mb-8">Como no canal público, o prazo de 15 dias começa quando a identidade do titular for verificada (registre a verificação na tela da solicitação).</p>
        <div className="form-group">
          <label>Descrição da solicitação</label>
          <textarea value={form.descricao} onChange={e => setForm({ ...form, descricao: e.target.value })} rows={4} placeholder="Descreva o pedido do titular..." />
        </div>

        <div className="btn-row-spread mt-20">
          <button onClick={onVoltar} className="btn-secondary btn-sm">Cancelar</button>
          <button onClick={salvar} disabled={loading} className="btn-primary btn-sm">
            {loading ? 'Criando...' : 'Registrar solicitação'}
          </button>
        </div>
      </div>
    </div>
  );
}
